/* src/app/main/pages/home-page/component/why-sat/why-sat.component.css */
.why-sat {
  background-color: #F8F9FF;
  position: relative;
}
.why-sat::before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/wew.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 190px;
  height: 100%;
  top: 0px;
}
.why-sat::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/wew-rotate.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 190px;
  height: 300px;
  bottom: -28px;
}
.specializaltion {
  padding: 22px 0px;
  width: 90%;
  margin-left: auto;
  background-color: #FFFFFF;
  margin-top: -80px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.specializaltion::before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/specialization-bg-img.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 50px auto;
  width: 60px;
  height: 100%;
  top: 0px;
}
.specializaltion .row {
  background-color: #FFFFFF;
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 30px;
}
.specializaltion ul li {
  font-family: "D-DIN-Bold";
  font-size: 17px;
  color: #191919;
  margin-top: 40px;
}
.specializaltion ul li:first-child {
  margin-top: 10px;
}
.specializaltion ul li img {
  border-radius: 100%;
  height: 30px;
  width: 30px;
  margin-right: 30px;
}
.get-quote-form {
  background-color: #fff;
  z-index: 1;
}
.get-quote-form h3 {
  font-size: 26px;
}
.get-quote-form textarea {
  resize: none;
}
.get-quote-form .form-control {
  background-color: #F0F0F0;
  border: none;
  border-left: 2px solid #213654;
  border-radius: 0;
  font-size: 14px;
  height: auto;
  padding: 8px 15px;
}
.get-quote-form .cust-form-control {
  padding: 8px 15px 8px 32px !important;
}
.pickup,
.destination {
  position: relative;
}
.pickup::before,
.destination::before {
  content: "";
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 100%;
  border: 1px solid #2C2C2C;
  left: 13px;
  top: 14px;
}
.pickup::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 43px;
  border: 1px solid #2C2C2C;
  left: 16px;
  top: 23px;
  z-index: 1;
}
.get-quote-form .form-group {
  margin-bottom: 15px;
}
.get-quote-form .btn {
  background-color: #E8882D;
  border: none;
  border-radius: 4px;
  font-family: "D-DIN-Bold";
  padding: 5px 40px;
}
.get-quote-form p {
  font-size: 14px;
}
input[type=date]::before {
  color: #505050;
  opacity: 0.8;
  content: attr(placeholder) ": ";
}
input[type=date]:focus::before {
  content: "" !important;
}
input[type=date] {
  position: relative;
}
::-webkit-calendar-picker-indicator {
  position: absolute;
  left: -20px;
  top: 10px;
}
.mailmodal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  display: block;
  background-color: rgb(0 0 0 / 0.4);
}
#mailack .modal-header {
  border-bottom: none;
}
#mailack .close {
  color: #E8882D;
  border: 1px solid #E8882D;
  border-radius: 100%;
  padding: 1px 7px;
  position: absolute;
  right: 13px;
  margin: 0;
  opacity: 1;
}
.modal-body {
  text-align: center;
  font-size: 16px;
  padding: 30px;
}
@media (max-width: 350px) {
  .get-quote-form .form-control {
    font-size: 12px;
  }
}
@media (min-width: 576px) {
  #mailack .modal-dialog {
    max-width: 550px;
  }
}
@media (min-width: 1920px) {
  .specializaltion ul li {
    font-size: 25px !important;
  }
  .get-quote-form .form-control {
    font-size: 20px !important;
    padding: 11px 20px !important;
  }
  .get-quote-form .cust-form-control {
    padding: 8px 15px 8px 40px !important;
  }
  .get-quote-form .form-group {
    margin-bottom: 20px;
  }
  .pickup::before,
  .destination::before {
    top: 19px;
  }
  .pickup::after {
    height: 55px;
    top: 29px;
  }
}
@media (min-width: 1600px) and (max-width: 1900px) {
  .pickup::after {
    height: 47px;
  }
  .get-quote-form .cust-form-control {
    padding: 8px 15px 8px 35px !important;
  }
}
@media (min-width: 1600px) {
  .get-quote-form {
    padding-top: 10px;
  }
  .get-quote-form h3 {
    font-size: 36px;
    margin-bottom: 25px !important;
  }
  .get-quote-form .form-control {
    padding: 9px 20px;
  }
  .specializaltion ul li {
    font-size: 22px;
  }
}
@media (min-device-width: 1440px) {
  .get-quote-form .form-control {
    font-size: 15px;
  }
  .get-quote-form .form-group {
    margin-bottom: 22px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .specializaltion ul li {
    font-size: 20px;
  }
}
@media (device-width: 1024px) {
  .specializaltion .row {
    padding-left: 0px;
  }
  .specializaltion .row ul {
    margin-top: 58px;
  }
}
@media (max-width: 768px) {
  .specializaltion {
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .specializaltion {
    width: 100%;
    margin-top: 20px;
    padding-top: 0px;
  }
  .specializaltion .row {
    padding-left: 0px;
  }
  .specializaltion .row ul {
    margin-bottom: 0px !important;
    padding-top: 0px !important;
  }
  .specializaltion ul li:first-child {
    margin-top: 30px;
  }
  .get-quote-form {
    background-color: #fff;
    margin-left: 8px;
    margin-right: 15px;
  }
}
@media (max-width: 355px) {
  .specializaltion ul li {
    font-size: 16px;
  }
  .specializaltion ul li img {
    height: 25px;
    width: 25px;
    margin-right: 10px;
  }
}
@-moz-document url-prefix() {
  .specializaltion ul li {
    margin-top: 50px !important;
  }
}
/*# sourceMappingURL=why-sat.component.css.map */
